import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Scrollchor from 'react-scrollchor';
import NoResults from '../NoResults/NoResults';
import LazyBg from '../../../UI/LazyImage/LazyBg';
import Info from '../Property/Info';

class PropertyList extends PureComponent {

    state = {
        activeId: null,
    }

    scrollchorRef = React.createRef()

    componentDidUpdate(prevProps) {
        const { propertyId } = this.props;
        const { activeId } = this.state;

        if (prevProps.propertyId !== propertyId) {
            const newActiveId = propertyId === null || propertyId === '' ? null : propertyId;
            const isValid = newActiveId !== null && newActiveId !== '';
            const hasChanged = newActiveId !== activeId;

            this.setState({ activeId: newActiveId }, () => {
                if (isValid && hasChanged) {
                    this.scrollchorRef.simulateClick();
                }
            });
        }
    }

    handleFocus = propertyId => {
        if (propertyId !== this.props.propertyId) {
            this.setState({ activeId: propertyId });
            this.props.handleMapClick(propertyId);
        }
    }

    render() {
        const { properties, propertyId, filters } = this.props;

        if (!properties) return null;
        if (properties.length === 0) return <NoResults />;

        return (
            properties.filter(property => property.showMarker).map(property => {
                const imgUrl = property.thumbnail
                    ? `${process.env.RAZZLE_ASSET_URL}${property.thumbnail}`
                    : '/thumbnail';

                return (
                    <Link key={property._id} to={`/office/${property.slug}`}>
                        <div
                            onMouseEnter={() => this.handleFocus(property._id)}
                            onMouseLeave={() => this.handleFocus(null)}
                            onFocus={() => this.handleFocus(property._id)}
                            onBlur={() => this.handleFocus(null)}
                        >
                            <Scrollchor
                                ref={ref => (this.scrollchorRef = ref)}
                                to={`property-id-${this.state.activeId}`}
                                target={'property-list-component'}
                                animate={{ duration: 250 }}
                                disableHistory={true}
                            />
                            <div>
                                <div
                                    id={`property-id-${property._id}`}
                                    className={property._id === propertyId ? 'property-card active' : 'property-card'}
                                >
                                    <div className='property-image'>
                                        <Link to={`/office/${property.slug}`} className='property-link'>
                                            <LazyBg src={imgUrl} className="hudson-logo" />
                                        </Link>
                                    </div>
                                    <div className='property-info'>
                                        <p className='property-title'>
                                            <Link to={`/office/${property.slug}`} className='property-link'>
                                                {property.name}
                                            </Link>
                                        </p>
                                        <p className='property-subtitle'>
                                            {`${property.city}, ${(property.state==='BRITISH COLUMBIA') ? 'BC' : property.state.substring(0, 2)}`}
                                        </p>
                                        <Info property={property} filters={filters} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                );
            })
        );
    }
}

PropertyList.propTypes = {
    propertyId: PropTypes.string,
    handleMapClick: PropTypes.func.isRequired,
    filters: PropTypes.object,
    properties: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        thumbnail: PropTypes.string,
    })),
};

export default PropertyList;
